import { useAuthStore } from '@/store/auth-store'
import { useControlCatalog } from '@/api/services/use-control-catalog-service'

/**
 * Phase 137+ — fires the `useControlCatalog` hook once at app shell level so
 * the module-scoped cache in `@/constants/control-labels` is hot before any
 * page renders. Renders nothing.
 *
 * Why a dedicated component instead of calling the hook in `MainLayout`
 * directly: this isolates the React-Query data dependency from the layout
 * tree's render path. Components mounted alongside this can call
 * `getControlLabel(key, lang)` synchronously and get hits from the cache
 * within ~1 fetch round-trip of mount.
 */
export const ControlCatalogBootstrap = (): null => {
  const { user } = useAuthStore()
  const companyId = user?.companyIds?.[0]
  useControlCatalog(companyId)
  return null
}
